gsap.registerPlugin(ScrollTrigger);

// ======================
// Lenis（スムーススクロール）
// ======================
const lenis = new Lenis({
  duration: 1.1,
  easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
  smoothWheel: true,
  smoothTouch: false,
});

lenis.on("scroll", ScrollTrigger.update);

function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}
requestAnimationFrame(raf);

// ======================
// マルキー（全ページ共通・安全版）
// ======================
const textSlides = document.querySelectorAll(".text-slide");

if (textSlides.length) {
  const allTweens = [];

  textSlides.forEach((slide) => {
    const track = slide.querySelector(".marquee-track");

    // DOM構造チェック
    if (!track || !track.firstElementChild) return;

    // === コンテンツ複製関数（安全版） ===
    function fillTrack() {
      // trackの子要素が存在しない場合は中断
      if (track.children.length === 0) return;

      // 初期幅が0（非表示）なら強制的に1ループで抜ける
      let safety = 0;
      while (track.scrollWidth < slide.clientWidth * 2 && safety < 20) {
        track.appendChild(track.firstElementChild.cloneNode(true));
        safety++;
      }
    }
    fillTrack();

    const loopDistance = track.scrollWidth / 2;

    // scrollWidthがゼロの場合はアニメーション無効化
    if (loopDistance <= 0) return;

    // 無限ループアニメーション
    const tween = gsap.to(track, {
      x: -loopDistance,
      ease: "none",
      duration: 40,
      repeat: -1,
      modifiers: {
        x: (x) => {
          const v = parseFloat(x);
          return ((v % -loopDistance) + "px");
        },
      },
    });

    allTweens.push(tween);
  });

  // スクロール速度連動
  lenis.on("scroll", ({ velocity }) => {
    const speed = gsap.utils.clamp(0.2, 3.5, 1 + velocity / 300);
    allTweens.forEach((t) => t.timeScale(speed));
  });
}

// ======================
// ヘッダー制御（共通）
// ======================
$(function () {
  $(".hum").click(function () {
    $("header").toggleClass("hum-open");
    $(".hum").toggleClass("active");
    $(".header_contents").toggleClass("active");
  });

  $(window).on("scroll", function () {
    if ($(this).scrollTop() > 600) {
      $("header").addClass("scrolled");
    } else {
      $("header").removeClass("scrolled");
    }
  });
});

$(function() {
  $('a[href^="#"]').click(function(e) {
    e.preventDefault();

    const href = $(this).attr('href');
    const target = $(href === '#' || href === '' ? 'html' : href);
    const headerHeight = $('header').outerHeight() || 0;

    const position = target.offset().top - headerHeight;

    $('html, body').animate({ scrollTop: position }, 600, 'swing');
  });
});